// removed by extract-text-webpack-plugin
module.exports = {"title":"qempo_modal_title-1KHItm0","content":"qempo_modal_content-1BrypZA","buttonsWrap":"qempo_modal_buttonsWrap-2uK1Y6J","column":"qempo_modal_column-3TNUB_J"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/modal.scss
// module id = 110
// module chunks = 0